export class  FS3Notification {
    type: string;
    text: string;
}
